"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = solveHorners;

var _decimal = require("./decimal.js");

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factorials = [1];


function fact(n) {
  if (!factorials[n]) {
    factorials[n] = fact(n - 1) * n;
  }
  return factorials[n];
}

function solveHorners(coeffs, t) {
  // Fastest solution, as shown in github:erosson/swarm-production experiments.
  // https://en.wikipedia.org/wiki/Horner's_method
  // http://jsbin.com/doqudoxopo/edit?html,output
  var ret = new _decimal2.default(0);
  for (var i = 0; i < coeffs.length; i++) {
    var degree = coeffs.length - i - 1;
    // ret * t + (coeffs[degree] / fact(degree)
    ret = ret.times(t).plus(coeffs[degree].div(fact(degree)));
  }
  return ret;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../growth/lib/polynomial.js
// module id = 371
// module chunks = 0